/**
 * Generic error message component
 * @module gui/components/error-message
 */
import React from 'react'
import { Set } from 'immutable'
import _toString from 'lodash/toString'
import './index.scss'

const baseClassName = 'error-message'
const classNameDefault = Set([baseClassName])

/**
 * A generic error message component
 * @param {Object} props React props
 * @param {Error|String} props.error The error
 * @param {Set} [props.className] An immutable set of class name for the component
 */
export default function ErrorMessage (props) {
  const { className = Set(), error, children } = props
  return (
    <div className={classNameDefault.concat(className).join(' ')}>
      { error && <span className={`${baseClassName}__text`}>{_toString(error)}</span> }
      {children}
    </div>
  )
}
